module.exports = __webpack_public_path__ + "img/stock3.6a1a3d38.png";